import Country from '../../models/Country';
import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';

export interface CountryDetailState extends ApiState {
  country?: Country
}

export default requestReducer<CountryDetailState>('COUNTRY_DETAIL')